import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceSubscription {
  getUserSubscription() {
    var config = {
      url: "/subscription",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getSubscriptionUpgrade() {
    var config = {
      url: "/plan/upgrade",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPlanByID(planID) {
    var config = {
      url: "/plan/" + planID,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  upgradeSubscription(data) {
    var config = {
      url: "/subscription/upgrade",
      method: "post",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }
}
